export default {
  "intro.text.one":
    "Dit jaar belooft de Tour de France opnieuw een heroïsche strijd te worden, eentje die we samen aangaan. Daarom is ons limited edition shirt geïnspireerd op The Swarm: een ode aan de kracht van samenwerking in actie. Zo bereiken we wat geen enkele bij alleen zou kunnen.",
  "intro.cta":
    'Schrijf je in, vorm The Swarm op ons shirt en ontvang <span class="cta__discount">10% korting</span>',
  "intro.button": "Schrijf in",
  "thanks.title": "Bedankt voor je inschrijving!",
  "thanks.text.one":
    "Je hebt meegeholpen The Swarm te vormen. Je ontvangt binnenkort 10% korting in je mailbox!",
  "form.label.nameAndEmail": "Vul je naam en e-mailadres in en vorm The Swarm.",
  "form.placeholder.name": "Voornaam",
  "form.placeholder.email": "E-mailadres",
  "form.label.newsletter":
    "Ja, Team Visma | Lease a Bike mag mij benaderen met interessante acties, evenementen en aanbiedingen",
  "form.label.terms":
    'Ja, ik ga akkoord met de <a href="https://www.teamvismaleaseabike.nl/privacy/" target="_blank">privacy voorwaarden</a>.',
  "form.button.submit": "Ga verder",
  "form.button.submitting": "Bezig met verzenden...",
  "form.error.name": "Dit veld is verplicht",
  "form.error.email.required": "Dit veld is verplicht",
  "form.error.email.invalid": "Voer een geldig e-mailadres in",
  "form.error.terms": "Je moet akkoord gaan met de voorwaarden",
  "form.error.submit":
    "Er is iets misgegaan bij het verzenden van het formulier. Probeer het opnieuw.",
};
